import { CustomizedButton } from 'components/common';
import classes from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/UploadRisksModal.module.scss';
import { AssigneeInput } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/components/FormContent/components/AssigneeInput/AssigneeInput';
import { FileUploadInput } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/components/FormContent/components/FileUploadInput/FileUploadInput';
import { TagsInput } from 'components/widgets/RiskRegister/components/UploadRisksButton/components/UploadRisksModal/components/FormContent/components/TagsInput/TagsInput';

export const FormContent = ({ closeModal }) => {
    return (
        <>
            <div className={classes.selectTitle}>Select file and optional assignee/tags</div>

            <FileUploadInput />
            <AssigneeInput />
            <TagsInput />

            <div className={classes.footer}>
                <div className={classes.container}>
                    <CustomizedButton size={'large'} color={'secondary'} onClick={closeModal}>
                        Cancel
                    </CustomizedButton>

                    <CustomizedButton size={'large'} color={'primary'} type={'submit'}>
                        Upload
                    </CustomizedButton>
                </div>
            </div>
        </>
    );
};
